// G3 Incidents (interface) : inscription du module. Les fichiers centraux (routeur, pages, navigation)
// reçoivent une ligne par module à l'intégration.

import { createElement } from 'react';
import { FicheIncident, RegistreIncidents, SignalerIncident } from './Incidents';

export const inscription = {
  code: 'G3',
  routes: [
    { chemin: '/incidents', element: createElement(RegistreIncidents) },
    { chemin: '/incidents/signaler', element: createElement(SignalerIncident) },
    { chemin: '/incidents/:id', element: createElement(FicheIncident) },
  ],
} as const;
